export default {
    routes: [
        {
            path: 'dashboard',
            name: 'dashboard',
            component: () => import('@/pages/organization/dashboard/Dashboard.vue')
        }
    ],
    nav: () => ({
        section: 'global',
        items: [
            {
                position: 1,
                title: i18n.t('Dashboard'),
                icon: 'view-dashboard',
                to: { name: 'dashboard' }
            }
        ]
    }),
    widgets: () => [
        {
            id: 'shortcuts',
            label: i18n.t('Quick access'),
            icon: 'rocket-launch-outline',
            component: () => import('@/pages/organization/dashboard/widgets/ModuleShortcuts.vue'),
            size: 'is-12'
        }
    ]
};
